export default function(state = [], action) {
  switch (action.type) {
    case 'SET_SCHOOLS':
      return action.schools
    default:
      return state
  }
}
